<template>
<div>
    <h3 class="columnTit"><span>排行榜</span></h3>
    <div class="topSwiper">
        <el-carousel height="611px" indicator-position="outside" :autoplay="false" arrow="always">
            <el-carousel-item v-if="rankSingle.length">
                <div class="topTit">
                    <div class="rankLeft">
                        <span>当季拍卖单品成交价 TOP10</span>
                    </div>
                    <a href="https://amma.artron.net/auctionrank.php" target="_blank" class="rankMore">查看更多</a>
                </div>
                <table class="rankTable">
                    <tr>
                        <th class="rankNumber">排名</th>
                        <th class="rankArtist">拍品名称</th>
                        <th class="rankCompany">成交价（元）</th>
                        <th class="rankPrice">成交时间</th>
                    </tr>
                    <tr v-for="(item,i) in rankSingle" :key="i">
                        <td class="rankNumber"><span>{{i+1}}</span></td>
                        <td class="rankArtist">
                            <router-link target="_blank" :to="{path:'/paimai-'+item.artCode}">{{item.show_title}}</router-link>
                        </td>
                        <template v-for="(info,idx) in item.extraInfo">
                            <td :key="idx" v-if="info.type == 'price'">
                                <!-- <router-link target="_blank" :to="{path:'/paimai-'+item.artCode}"><span class="price" style="color: #F5222D;">{{info.smallText}} {{info.text}}</span></router-link> -->
                                <router-link target="_blank" :to="{path:'/paimai-'+item.artCode}">
                                    <template v-if="isMem==1">
                                        <span class="price" style="color: #F5222D;">{{info.smallText}} {{info.text}}</span>
                                    </template>
                                    <template v-else><a style="color: #F5222D;" href="javascript:;" @click="gotoLogin">{{info.smallText}} {{info.nonMemberText}}</a></template>
                                </router-link>
                            </td>
                            <td :key="idx" v-if="info.label=='成交时间'" class="rankPrice">{{info.text}}</td>
                        </template>
                    </tr>
                </table>
            </el-carousel-item>
            <el-carousel-item v-if="rankCompany.length">
                <div class="topTit">
                    <div class="rankLeft">
                        <span>当季拍卖公司成交额 TOP10</span>
                    </div>
                    <a href="https://amma.artron.net/auctionrank.php" target="_blank" class="rankMore">查看更多</a>
                </div>
                <table class="rankTable">
                    <tr>
                        <th class="rankNumber">排名</th>
                        <th class="rankArtist">拍卖公司</th>
                        <th class="rankCompany">拍卖场次</th>
                        <th class="rankPrice">总成交额</th>
                    </tr>
                    <tr v-for="(item,i) in rankCompany" :key="i">
                        <td class="rankNumber"><span>{{i+1}}</span></td>
                        <td class="rankArtist">
                            <a :href="item.pc_url" target="_blank">{{item.company_name}}</a>
                            <!--                                <span class="comFlag" v-if="item.pc_extra_info">-->
                            <!--                                            <a href="https://auction.artron.net/gongyue.php" v-if="item.pc_extra_info.IsZhongPai > 0" target="_blank" class="flagText" title="《中国文物艺术品拍卖企业自律公约》成员单位">GY</a>-->
                            <!--                                            <i v-if="item.pc_extra_info.IsStandard > 0" title="中国文物艺术品拍卖标准化达标企业" class="flagText">DB</i>-->
                            <!--                                            <a href="https://auction.artron.net/help/introduce/html/introduce_brand.html" target="_blank" v-if="item.pc_extra_info.ZoneName !=''"><img src="../../assets/imgs/zoom.png" alt="已开通官网"></a>-->
                            <!--                                            <i v-if="item.pc_extra_info.isBeian > 0"><img src="" alt="备案"></i>-->
                            <!--                                        </span>-->
                        </td>
                        <td class="rankCompany">{{ item.auction_times }}</td>
                        <td class="rankPrice">
                            {{item.deal_price}} {{item.currency}}
                        </td>
                    </tr>
                </table>
            </el-carousel-item>
            <el-carousel-item v-if="rankArtists.length">
                <div class="topTit">
                    <div class="rankLeft">
                        <span>当季艺术家作品指数成交额 TOP10</span>
                        <el-select v-model="selectVal" placeholder="油画" @change="selectClass" popper-class="rankSelect" :popper-append-to-body="false">
                            <el-option v-for="(item,i) in rankClasses" :key="i" :label="item.class_name" :value="item.class_name">
                            </el-option>
                        </el-select>
                    </div>
                    <a href="https://amma.artron.net/auctionrank.php" target="_blank" class="rankMore">查看更多</a>
                </div>
                <table class="rankTable">
                    <tr>
                        <th class="rankNumber">排名</th>
                        <th class="rankArtist">艺术家</th>
                        <th class="rankCompany">当前成交额</th>
                        <th class="rankPrice">总成交金额</th>
                    </tr>
                    <tr v-for="(item,i) in rankArtist" :key="i">
                        <td class="rankNumber"><span>{{i+1}}</span></td>
                        <td class="rankArtist"><a :href="item.pc_url" target="_blank">{{item.artist_name}}</a></td>
                        <td class="rankCompany"><span class="price">{{item.currency}} {{ item.current_price }} </span></td>
                        <td class="rankPrice">{{item.currency}} {{item.total_price}}</td>
                    </tr>
                </table>
            </el-carousel-item>
            <el-carousel-item v-if="rankHistory.length">
                <div class="topTit">
                    <div class="rankLeft">
                        <span>历史拍品成交价 TOP10</span>
                    </div>
                    <a href="https://amma.artron.net/auctionrank.php" target="_blank" class="rankMore">查看更多</a>
                </div>
                <table class="rankTable">
                    <tr>
                        <th class="rankNumber">排名</th>
                        <th class="rankArtist">拍品名称</th>
                        <th class="rankCompany">成交价</th>
                        <th class="rankPrice">成交时间</th>
                    </tr>
                    <tr v-for="(item,i) in rankHistory" :key="i">
                        <td class="rankNumber"><span>{{i+1}}</span></td>
                        <td class="rankArtist">
                            <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank">{{item.detail.workName}}</router-link>
                        </td>
                        <template v-for="(info,idx) in item.extraInfo">
                            <td :key="idx" v-if="info.type == 'price'">
                                <!-- <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank"><span class="price" style="color:#F5222D;">{{info.smallText}} {{info.text}} </span></router-link> -->
                                <router-link :to="{path:'/paimai-'+item.artCode}" target="_blank"> <template v-if="isMem==1">
                                        <span class="price" style="color: #F5222D;">{{info.smallText}} {{info.text}} </span>
                                    </template>
                                    <template v-else>
                                        <a href="javascript:;" style="color: #F5222D;" @click="gotoLogin">{{info.smallText}} {{info.nonMemberText}}</a>
                                    </template>
                                </router-link>

                            </td>
                            <td :key="idx" v-if="info.label=='成交时间'" class="rankPrice">{{info.text}}</td>
                        </template>
                    </tr>
                </table>
            </el-carousel-item>
        </el-carousel>
    </div>
</div>
</template>

<script>
import {
    getRank
} from "@/api/index";
import {
    getMemType
} from "@/api/auction";
export default {
    name: "indexRank",
    props: ['isLogin'],
    data() {
        return {
            isMem:0,
            rankArtists: [],
            rankClasses: [],
            rankCompany: [],
            rankHistory: [],
            rankSingle: [],
            rankArtist: [],
            className: [],
            selectVal: '油画'
        }
    },
    mounted() {
        this.getRank();
        this.getMemType();
    },
    methods: {
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                }
            })
        },
        getRank() {
            getRank().then((res) => {
                this.rankArtists = res.data.artist
                this.rankClasses = res.data.classes
                this.rankCompany = res.data.company
                this.rankHistory = res.data.history
                this.rankSingle = res.data.single
                this.rankArtist = res.data.artist.length ? res.data.artist[0].list : []
                this.className = res.data.classes.length ? res.data.classes[0].class_name : []
            });
        },
        selectClass(name) {
            let artistList = this.rankArtists,
                that = this;
            artistList.forEach(function (item) {
                if (item.class_name == name) {
                    that.rankArtist = [];
                    that.rankArtist = item.list;
                    that.className = item.class_name
                }
            });
        },
        gotoLogin() {
            if(this.isLogin==0){
                window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
            }else{
                window.location.href='https://member.artron.net/memCenter/collect?business_id=50001&source_page=6&sourceReferer='+encodeURIComponent(window.location.href)
            }

            

        }
    }
}
</script>

<style lang="scss" scoped>
/*排行榜*/
.topSwiper {
    position: relative;

    /deep/.el-carousel--horizontal {
        padding-top: 50px;
        margin-top: -50px;
    }

    .topTit {
        display: flex;
        justify-content: space-between;
        background-color: #fafafa;
        border: 1px solid #D9D9D9;
        padding: 0 20px;
        height: 60px;
        align-items: center;

        .rankLeft {
            font-size: 0;

            span {
                font-size: 18px;
                font-weight: bold;
                color: #262626;
            }
        }

        /deep/.el-select {
            margin-left: 20px;
            width: 120px;

            .el-input__inner {
                height: 24px;
                line-height: 24px;
                border: 1px solid #D9D9D9;
                color: #262626;
                padding: 0 10px;
                font-family: "Microsoft YaHei";
            }

            .el-input__icon {
                line-height: 24px;
            }
        }
    }

    .rankTable {
        width: 100%;
        border: 0;
        border-collapse: collapse;

        td,
        th {
            height: 50px;
            border-bottom: 1px solid #f2f2f2;
        }

        th {
            font-weight: bold;
            color: #262626;
        }

        .rankNumber {
            width: 104px;

            span {
                display: inline-block;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                color: #fff;
                border-radius: 4px;
                background-color: #BFBFBF;
            }
        }

        .price {
            color: #F5222D
        }

        tr:nth-child(2) {
            .rankNumber {
                span {
                    background-color: #F05008;
                }
            }
        }

        tr:nth-child(3) {
            .rankNumber {
                span {
                    background-color: #F27D00;
                }
            }
        }

        tr:nth-child(4) {
            .rankNumber {
                span {
                    background-color: #F2A207;
                }
            }
        }

        .rankArtist {
            width: 300px;

            a {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 300px;
                padding-right: 10px;
            }
        }

        .rankCompany {
            width: 193px;
            padding: 0 20px;
        }

        .rankPrice {
            text-align: right;
        }
    }

    /deep/.el-carousel__indicators--outside {
        position: absolute;
        top: 3px;
        right: 74px;
        left: inherit;

        .el-carousel__indicator--horizontal {
            padding: 0;
            margin-left: 10px;

            .el-carousel__button {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #F2F2F2;
                opacity: 1;
            }
        }

        .el-carousel__indicator.is-active button {
            background-color: #329D15;
        }
    }

    /deep/.el-carousel__arrow {
        width: 20px;
        height: 20px;
        background-color: #329d15;
        top: -46px;
        transform: translateY(0);
        display: block !important;
    }

    /deep/.el-carousel__arrow:hover {
        background-color: #5BB144;
    }

    /deep/.el-carousel__arrow--left {
        left: inherit;
        right: 34px;
    }

    /deep/.el-carousel__arrow--right {
        right: 0;
    }

    .flagText {
        display: inline-block;
        width: 25px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 12px;
        margin-right: 2px;
    }
}

/deep/.rankSelect {
    margin: 5px 0;

    .el-select-dropdown__item {
        height: 30px;
        line-height: 30px;
        text-align: center;
    }

    .el-select-dropdown__item.selected {
        color: #329d15;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        background: transparent;
        color: #329d15;
    }

    .popper__arrow {
        display: none;
    }
}
</style>
